import { HttpInterceptor, HttpRequest, HttpHandler, HttpErrorResponse } from '@angular/common/http';import { Injectable } from '@angular/core';
import { defer, throwError } from 'rxjs';import { catchError, finalize, tap } from 'rxjs/operators';
import { TimerService } from '../services/timer.service';
@Injectable()export class PerformanceInterceptor implements HttpInterceptor {
  activeRequests = 0;

    constructor(private timerService:TimerService){}
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return defer(() => {
       if (this.activeRequests === 0) {
    //   if (!req.url.includes('authenticate/v1/token')) {
        //   }
    }
    const urlsForTimer =[
        'api/lgiindia/partnerportal/orchestration/renewal/v1/details',
        'api/integration/v1/vehicleDetails',
        'api/lgiindia/partnerportal/orchestration/proposal/v1/kycArya/verifyCustomerKyc',
        'api/lgiindia/partnerportal/orchestration/quote/v1/draft',
        'api/lgiindia/partnerportal/claim/v1/intimateclaim'
    ]
    if(urlsForTimer.some(url=>req.url.includes(url))){
        this.timerService.startTimer();
    }
    this.activeRequests++;
      return next.handle(req).pipe(
        finalize(() => { 
          this.timerService.stopTimer();
      }),
      catchError((error: HttpErrorResponse) => { 
      this.timerService.stopTimer();
        return throwError(error.error.error.errorMessage);
      }));
    });
  }
}